import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import type { MobileGatewayV2 } from '@src/@types/promo';

import type { IGlobalState } from '.';

type IState = MobileGatewayV2.IUserPromoResponse | null;

export type TPromoContent = {
  bonusAmount: number;
  rulesLink: string;
  startDate: string;
  endDate: string;
};

const initialState: IState = null;

export const setPromo = createAction<IState>('promo/set');

export const promoReducer = createReducer<IState>({}, initialState).on(setPromo, (_state, payload) => payload);

const getPromo = (state: IGlobalState) => state.promo;
const getPromoContent = (state: IGlobalState): TPromoContent => {
  const promo = getPromo(state);

  if (promo) {
    return {
      bonusAmount: promo.rewards.money,
      rulesLink: promo.rulesLink,
      startDate: promo.activityDates.from,
      endDate: promo.activityDates.to,
    };
  }

  return {
    bonusAmount: 0,
    rulesLink: '',
    startDate: '',
    endDate: '',
  };
};

export const useUserPromo = () => useSelector(getPromo);
export const useUserPromoContent = () => useSelector(getPromoContent);

export const useIsPromoActive = () => Boolean(useSelector(getPromo)?.isActive);
